/* faq-page.js — piper & mint FAQ accordion */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var items = document.querySelectorAll('.faq-item__button');
    if (!items.length) return;

    items.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item');
        var isOpen = item.classList.contains('faq-item--open');

        // Close all items in the same category
        var category = item.closest('.faq-category');
        if (category) {
          category.querySelectorAll('.faq-item--open').forEach(function (openItem) {
            openItem.classList.remove('faq-item--open');
            openItem.querySelector('.faq-item__button').setAttribute('aria-expanded', 'false');
          });
        }

        // Toggle clicked item
        if (!isOpen) {
          item.classList.add('faq-item--open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Smooth scroll for TOC links
    document.querySelectorAll('.faq-toc__link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  });
})();
